<div style="min-height: 30vh;">
    <button class="close" mat-button (click)="onClickNo()">X</button>
    <mat-dialog-content>
        <div >
            <div style="border: 1px solid gray; padding: 5px;">
                <h4 > <b>Choose an option to update result manually.</b></h4>
            </div>
            
            <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="selectedOption" (selectionChange)="manualUpdate()">
                    <mat-option *ngFor="let opt of optionList" [value]="opt">
                        {{opt | titlecase}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            
        </div>
    </mat-dialog-content>
</div>
